import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoader2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-loader-circle",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
});
export { SvgLoader2 as ReactComponent };
